var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClassicBenefitSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.916687 10.9993C0.916687 5.43335 5.43402 0.916016 11 0.916016C16.566 0.916016 21.0834 5.43335 21.0834 10.9993C21.0834 16.5654 16.566 21.0827 11 21.0827C5.43402 21.0827 0.916687 16.5654 0.916687 10.9993ZM3.94169 10.9993L8.98335 16.041L18.0584 6.96602L16.6366 5.53418L8.98335 13.1874L5.36344 9.5776L3.94169 10.9993Z",
    fill: "#6E6E77"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassicBenefitSuccess);
export default __webpack_public_path__ + "static/media/classic-benefit-success.f07cd16d9c98b52dff4fa5ecbfe8b0e5.svg";
export { ForwardRef as ReactComponent };